import React from 'react';
import TextField from '@material-ui/core/TextField';
import { isEmpty } from 'lodash';
import IntlMessages from '../../../../../util/IntlMessages';

function Orgnr(props) {
    return (
        <div>
           <TextField
           fullWidth
          //  error={isEmpty(props.Orgnr)}
           disabled
           defaultValue=""
           variant="outlined"
           size="small"
           name="title"
           label={<IntlMessages id="appKontoModule.organisationsnummer"/>}
           value={props.Orgnr}
           InputLabelProps={{ shrink: true }}
           /> 
        </div>
    );
}

export default Orgnr;